/**
 * To be documented the reason for
 */

export const DELIVERY_MODAL = 1500;
export const AUTHENTICATION_MODAL = 1301;
